const Theme = Object.freeze({
  LIGHT: 'Light',
  DARK: 'Dark',
})

export default Theme
